module.exports = __webpack_public_path__ + "static/media/201708212323440581_TCS-iON-ICSI-ink-pact-for-digital-learning_SECVPF.cb371c9e.gif";